// Module
var code = "<div class=\"icon-badge\" :style=\"{ background: badgeData.bgColor, color: badgeData.textColor}\" :class=\"{ 'icon-badge-button' : badgeData.emit }\" @click=\"emit()\"> <icon :name=\"badgeData.icon\"></icon> {{ badgeData.label }} </div> ";
// Exports
export default code;